/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2026
///                                    RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { API, CancelToken } from "./axios";
import { stringify } from "query-string";

let cancelCallback;

export const getPendingBids = userRoleForPendingBidsWhenManagementUser =>
  API.get("api/v1.0/bids/pending-bids", {
    params: { userRoleForPendingBidsWhenManagementUser }
  });

export const acceptBid = (bidId, bidModeId, userRoleForBidWhenManagementUser) =>
  API.post(`api/v1.0/bids/${bidId}/mode/${bidModeId}/accept`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const rejectBid = (
  bidId,
  bidModeId,
  rejectReason,
  userRoleForBidWhenManagementUser
) =>
  API.post(
    `api/v1.0/bids/${bidId}/mode/${bidModeId}/reject`,
    { rejectReason },
    {
      params: {
        userRoleForBidWhenManagementUser
      }
    }
  );

export const postNewBid = bid => {
  return API.post("api/v1.0/bids", bid);
};

export const getBidNameExistsForShipper = (name, shipperId) => {
  return API.get("api/v1.0/bids/bid-name-exists/", {
    params: {
      name: name,
      shipperId: shipperId
    }
  });
};

export const getBidSummary = bidId =>
  API.get("api/v1.0/bids/" + bidId + "/summary");

export const getBidDetails = bidId => API.get("api/v1.0/bids/" + bidId);

export const updateBidDetails = bid => API.put("api/v1.0/bids", bid);

export const getAllBids = params => {
  cancelCallback && cancelCallback("Cancelled By User");

  return API.get("api/v1.0/bids/search?" + stringify(params), {
    cancelToken: new CancelToken(function executor(cancelToken) {
      cancelCallback = cancelToken;
    })
  });
};

export const archiveBid = (
  bidId,
  bidModeId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`api/v1.0/bids/${bidId}/mode/${bidModeId}/archive`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const setModeStatusForPricingSubmitted = (
  bidId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`api/v1.0/bids/${bidId}/lane-pricing-submitted`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const setModeStatusForAwardUploaded = (bidId, awardedModes) =>
  API.post(`api/v1.0/bids/${bidId}/awards-uploaded`, awardedModes);

export const setModeStatusForSelfPricedAwardsUploaded = (bidId, body) =>
  API.post(`api/v1.0/bids/${bidId}/self-priced-awards-uploaded`, body);

export const getActiveBids = userRoleForActiveBidsWhenManagementUser =>
  API.get(`api/v2.0/bids/active-bids`, {
    params: { userRoleForActiveBidsWhenManagementUser }
  });

export const openNextRoundForBid = (bidId, openNextRoundRequest) =>
  API.post(`api/v1.0/bids/${bidId}/open-next-round`, openNextRoundRequest);

export const closeAllModesForBidLost = bidId =>
  API.post(`api/v1.0/bids/${bidId}/close-lost`);

export const closeAllModesForBidLostWithCrm = (bidId, body) =>
  API.post(`api/v1.0/bids/${bidId}/close-lost-crm`, body);

export const closeBidWon = (bidId, userRoleForBidWhenManagementUser) =>
  API.post(`api/v1.0/bids/${bidId}/close-won`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const closeBidMode = (bidId, userRoleForBidWhenManagementUser) =>
  API.post(`api/v1.0/bids/${bidId}/close`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const revertBidModeStatusChange = (bidId, bidModeId) =>
  API.post(`api/v1.0/bids/${bidId}/mode/${bidModeId}/revert-status-change`);

export const manualRepriceForBid = bidId =>
  API.post(`api/v1.0/bids/${bidId}/reprice-truckload-lanes`);

export const getBidShipperHistory = (bidId, userRoleForBidWhenManagementUser) =>
  API.get("api/v1.0/bids/" + bidId + "/shipper-history", {
    params: { userRoleForBidWhenManagementUser }
  });

export const deleteBid = bidId =>
  API.delete(`api/v1.0/bids/bidId`, { params: { bidId } });

export const editBidStrategyDates = (
  bidId,
  strategicStartDateUTC,
  strategicEndDateUTC
) => {
  return API.put(`api/v1.0/bids/${bidId}/edit-strategic-dates`, null, {
    params: {
      strategicStartDateUTC,
      strategicEndDateUTC
    },
    paramsSerializer: params => stringify(params)
  });
};

export const getOpportunityNames = shipperId =>
  API.get(`api/v1.0/bids/opportunity-names/${shipperId}`);

export const getOpportunity = opportunityId =>
  API.get(`api/v1.0/bids/rfq-opportunity/${opportunityId}`);

export const getAccountOpportunityNames = shipperId =>
  API.get(`api/v1.0/bids/opportunity-names/customer/${shipperId}`);

export const getBidNameExists = name => {
  return API.get("api/v1.0/bids/is-bid-name-exists/", {
    params: {
      name: name
    }
  });
};
